<div class="row">
    <div class="col-12 text-end" style="height:50px;background-color: #002F87;border: 1px black solid;">
        <div style="margin-top:10px;">
            <span style="font-size:28px;color:white"><strong>Invoice Details</strong></span>
        </div>
    </div>
 </div>


<div class="row billingLine" style="height:50px;">
    <div class="col-1 text-center" >
        <span class="billing-line-title">Qty</span>
    </div>
     <div class="col-1 text-center">
        <span class="billing-line-title">Rate</span>
    </div>
     <div class="col-1 text-center">
        <span class="billing-line-title">Rev Type</span>
    </div>
     <div class="col-4 text-center">
        <span class="billing-line-title">Description</span>
    </div>
     <div class="col-1 text-center">
        <span class="billing-line-title">Seq Start</span>
    </div>
     <div class="col-1 text-center">
        <span class="billing-line-title">Seq End</span>
    </div>
     <div class="col-1 text-end">
        <span class="billing-line-title">Amount</span>
    </div>
     <div class="col-1 text-end">
        <span class="billing-line-title">Tax</span>
    </div>
      <div class="col-1 text-end">
        <span class="billing-line-title">Totals</span>
    </div>
</div>
    

@for(line of miBillingLines; track line.billingLine){
    <div class="row billingLine">
        <div class="col-1 text-center" style="height:60px;">
            {{line.quantity}}
        </div>
        <div class="col-1 text-center" >
            {{line.rate | currency}}
        </div>
        <div class="col-1 text-center" >
            {{line.revType}}
        </div>
        <div class="col-4 text-center" >
            {{line.description}}
        </div>
        <div class="col-1 text-center" >
            {{line.sequenceStart}}
        </div>
        <div class="col-1 text-center" >
            {{line.sequenceEnd}}
        </div>
        <div class="col-1 text-end" >
            {{line.amount | currency}}
        </div>
        <div class="col-1 text-end" >
            {{line.tax | currency}}
        </div>
        <div class="col-1 text-end">
            {{line.total | currency}}
        </div>
    </div>
}




    
    <div class="row" style="margin-top:20px;">
        <div class="col-9 text-end" style="height:60px;">
           <span class="billing-line-title">Subtotal</span>
        </div>
      
        <div class="col-1 text-end" >
            <span class="billing-line-title">$1,000.00</span>
        </div>
        <div class="col-1 text-end" >
            <span class="billing-line-title">$125.00</span>
        </div>
        <div class="col-1 text-end">
            <span class="billing-line-title">S1,125.00</span>
        </div>
    </div>
